import React, { FC, memo } from 'react';
import { FormItemProps, ModalFuncProps } from 'antd';
import { Button, Form, Modal } from 'udesk-ui';
import VerifyCodeInput, {
    TemplateProps as VerifyCodeInputProps,
} from './components/VerifyCodeInput';
import UdeskLocales, { LOCALES_MAP } from 'UdeskLocales';
import moment from 'moment';
import './style.scss';

interface VerifyModalProps extends ModalFuncProps {
    onLogin: (code?: string) => void;
    langCode?: string;
    validateStatus?: FormItemProps['validateStatus'];
    help?: string;
    verifyParams: VerifyCodeInputProps['params'];
    loading?: boolean;
}

interface FormModel {
    code?: string;
}

const Template: FC<VerifyModalProps> = memo((props) => {
    const {
        onLogin,
        langCode = 'zh',
        validateStatus,
        help,
        verifyParams,
        loading,
        ...modalProps
    } = props;

    moment.locale(LOCALES_MAP.zh.moment);
    if (Object.prototype.hasOwnProperty.call(LOCALES_MAP, langCode)) {
        UdeskLocales.setLanguage(LOCALES_MAP[langCode].language);
        moment.locale(LOCALES_MAP[langCode].moment);
    }

    const [form] = Form.useForm<FormModel>();

    const onFinish = () => {
        form.validateFields().then(() => {
            const values = form.getFieldsValue();
            const code = values.code;
            onLogin?.(code);
        });
    };

    return (
        <Modal
            {...modalProps}
            title={/* 验证码 */ UdeskLocales['current'].components.verifyModal.index.cAPTCHA}
            maskClosable={false}
            footer={
                <Button type="primary" onClick={onFinish} disabled={loading} loading={loading}>
                    {/* 确定 */}
                    {UdeskLocales['current'].components.verifyModal.index.confirm}
                </Button>
            }
            wrapClassName="verify-modal"
            destroyOnClose
        >
            <Form form={form} layout="vertical">
                <Form.Item
                    label={
                        /* 请输入验证码 */ UdeskLocales['current'].components.verifyModal.index
                            .pleaseEnterTheVerificationCode
                    }
                    name="code"
                    rules={[
                        {
                            required: true,
                            message:
                                /* 请输入验证码 */ UdeskLocales['current'].components.verifyModal
                                    .index.pleaseEnterTheVerificationCode,
                        },
                    ]}
                    validateStatus={validateStatus}
                    help={help}
                    preserve={false}
                >
                    <VerifyCodeInput params={verifyParams} />
                </Form.Item>
            </Form>
        </Modal>
    );
});

export default Template;
